// change the state inside the store, setter
// import Vue from "vue";

const moduleMutations = {
  setRooms(state, { rooms }) {
    state.rooms = rooms;
    // Vue.set(state.rooms, rooms.id, rooms);
  }
};

export default moduleMutations;
